import httpService from "../_utils/http-service";
import * as types from "./types";
import { getAuthHttpConfig } from "../_utils/auth-utils";
import { resetAll } from "./_restaurants-action";
import { traceEvent, reportError } from "../_utils/analytics-utils";

// HOST actions
export const createGroupOrder = (customerId, restaurantId, callback) => {
  return function(dispatch, getState) {
    traceEvent("group order", "create");
    const storage = getState().storage;
    const payload = {
      serviceTypeId: 1,
      restaurantId,
      generateJoinLink: true,
      customers: [
        {
          id: customerId,
          isHost: 1,
          dishes: [],
          specialRequest: ""
        }
      ]
    };

    httpService
      .post(
        `customers/${customerId}/order`,
        payload,
        getAuthHttpConfig(storage)
      )
      .then(res => {
        if (res.data.statusCode === 200) {
          const order = res.data.data;
          const url = order.joinInfo.deepLink;

          dispatch({ type: types.HOST_SET_URL, payload: url });
          callback({
            success: true,
            order,
            url
          });
        } else {
          callback({
            success: false
          });
          traceEvent("error", "createGroupOrder");
        }
      })
      .catch(err => {
        callback({ success: false });
        traceEvent("error", "createGroupOrder");
      });
  };
};

export const createGroupOrderLink = (orderId, callback) => {
  return function(dispatch, getState) {
    const storage = getState().storage;
    traceEvent("group order link", "create");
    httpService
      .post(`/order/${orderId}/join/link`, null, getAuthHttpConfig(storage))
      .then(res => {
        if (res.data.statusCode === 200) {
          const url = res.data.data.deepLink;

          dispatch({
            type: types.HOST_SET_URL,
            payload: url
          });
          callback({
            success: true,
            url
          });
        } else {
          callback({
            success: false
          });
          reportError("createGroupOrderLink", { res });
        }
      });
  };
};

export const clearGroupOrderInfo = () => {
  return { type: types.CLEAR_GROUP_ORDER_INFO };
};

export const toggleGuestsExpanded = () => {
  return { type: types.TOGGLE_GUESTS_EXPANDED };
};

//Guest actions
export const fetchHostOrder = (joinToken, callback) => {
  return function(dispatch) {
    resetAll(dispatch);

    httpService
      .get(`/order/join/${joinToken}`)
      .then(res => {
        if (res.data.statusCode === 200) {
          callback({
            success: true,
            order: res.data.data
          });
        } else {
          reportError("fetchHostOrder", { res });
          callback({
            success: false,
            error: res.data.message
          });
        }
      })
      .catch(err => {
        reportError("fetchHostOrder", { err });
        callback({
          success: false,
          error: ""
        });
      });
  };
};
